import gql from "graphql-tag";

export type RenewTokenResult = { renew: string };
export const renewToken = gql`
  query renewToken {
    renew
  }
`;
